//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// Assets ----------------------------------------------------------------------
import { ChevronLeftIcon, ChevronRightIcon } from '@cmp/images';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class Paginate extends React.Component {
  constructor(props) {
    super(props);
  }

  getRangeArray(numberOfPages) {
    const range = [];
    const n = numberOfPages >= 1 ? numberOfPages : 1;
    for (let i = 1; i <= n; i++) range.push(i);
    return range;
  }

  render() {
    const { onPrevious, onNext, onPageNumber, page, numberOfPages } =
      this.props;
    const range = this.getRangeArray(numberOfPages);

    return (
      <div className={styles.Paginate}>
        <ChevronLeftIcon
          className={styles.Icon}
          onClick={onPrevious}
          tabIndex="0"
        />
        {range.map((el, index) => {
          return (
            <button
              key={index}
              className={classNames(styles.Number, {
                [styles.Selected]: el === page,
              })}
              tabIndex="-1"
              onClick={() => onPageNumber(el)}
            >
              {el}
            </button>
          );
        })}
        <ChevronRightIcon
          className={styles.Icon}
          onClick={onNext}
          tabIndex="0"
        />
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default Paginate;
